<script setup lang="ts">

</script>

<template>
	<div class="inline-flex items-center">
		<span class="font-mono whitespace-nowrap text-dimmed">--</span>
	</div>
</template>
